<template lang="pug">
div
  .formPage(:class="{'is-succeed':successSend}")
    .formPage-success
      .formPage-success-content
        h2(v-if="rateLast") {{$t(`rates.${rateLast}`)}}
        h2(v-else) {{$t('thankYouMessage')}}
        a.button-link.is-small(@click.prevent="successSend = false") {{$t('submitAnotherFeedback')}}
    section.u-mt-md
      AppTitle.u-mb-0(:title="$t('mantra')")
    section.u-mt-md.u-mb-md
      .grid
        .column.is-ultrawide-6.is-widescreen-8
          ValidationObserver(ref="observer")
            form(slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" novalidate)
              div
                ul.feedback
                  li.happy(@click="rate = 5" :class="{'active': rate == 5}")
                    div
                      svg.eye.left
                        use(xlink:href='#eye')
                      svg.eye.right
                        use(xlink:href='#eye')
                    span.feedback-text {{$t('happy')}}
                  li.good(@click="rate = 4" :class="{'active': rate == 4}")
                    div
                      svg.eye.left
                        use(xlink:href='#eye')
                      svg.eye.right
                        use(xlink:href='#eye')
                      svg.mouth
                        use(xlink:href='#mouth')
                    span.feedback-text {{$t('good')}}
                  li.ok(@click="rate = 3" :class="{'active': rate == 3}")
                    div
                    span.feedback-text {{$t('ok')}}
                  li.sad(@click="rate = 2" :class="{'active': rate == 2}")
                    div
                      svg.eye.left
                        use(xlink:href='#eye')
                      svg.eye.right
                        use(xlink:href='#eye')
                      svg.mouth
                        use(xlink:href='#mouth')
                    span.feedback-text {{$t('sad')}}
                  li.angry(@click="rate = 1" :class="{'active': rate == 1}")
                    div
                      svg.eye.left
                        use(xlink:href='#eye')
                      svg.eye.right
                        use(xlink:href='#eye')
                      svg.mouth
                        use(xlink:href='#mouth')
                    span.feedback-text {{$t('angry')}}
                svg(xmlns='http://www.w3.org/2000/svg' style='display: none;')
                  symbol#eye(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 7 4')
                    path(d='M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1')
                  symbol#mouth(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 7')
                    path(d='M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5')
              ValidationProvider( name=" " rules="required" ref="provider" v-slot="{ errors }" slim)
                .form
                  input.u-hide(v-model="rate")
                  transition(name="validation")
                    p(v-if="errors[0]").form-error {{ errors[0] }}
              SelectInput(
                v-model="reason"
                track-by="value"
                :name="$t('forms.reason')"
                :label="$t('forms.reason')"
                label-by="title"
                :options="reasons"
                :searchable="true"
                :close-on-select="true"
                data-vv-name="reason"
                rules="required"
              )
              TextInput(
                v-model="title"
                type="text"
                :label="$t('forms.subject')"
                rules="required"
              )
              TextInput(
                name="message"
                v-model="message"
                type="textarea"
                :label="$t('forms.message')"
                rules="required"
              )
              .feedbackBox.u-mb-xs
                .feedbackBox-header
                  b {{$t('contactDetails')}}  #[span.u-cl-success {{$t('forms.optional')}}]
                  a.button-link.is-small(@click.prevent="showOptional = !showOptional")
                    span(v-if="showOptional")  {{$t('skip')}}
                    span(v-else) {{$t('show')}}
                .feedbackBox-body(v-if="showOptional")
                  .grid.is-tablet-6
                    .column
                      TextInput(
                        v-model="firstName"
                        type="text"
                        :label="$t('forms.fname')"
                      )
                    .column
                      TextInput(
                        v-model="lastName"
                        type="text"
                        :label="$t('forms.lname')"
                      )
                  TextInput(
                    v-model="email"
                    type="email"
                    :label="$t('forms.email')"
                    rules="email"
                  )
                  PhoneInput(
                    :name="$t('forms.phone')"
                    type="text"
                    :label="$t('forms.phone')"
                    v-model="phone"
                    ref="phoneNumber"
                  )
              .u-mb-ts
                recaptcha(@error="onError" @success="onSuccess" @expired="onExpired")
              button.button-link.is-large(v-load="isSubmitting") {{$t('forms.send')}}
    section.u-mt-md
      .grid.is-tablet-6.is-labs
        .column.u-mb-col
          AppCardBox
            AppLink(to="/cc" :title="$t('cc')"  class="cardBox-url")
            h4 {{$t('cc')}}
            p {{$t('ccDesc')}}
        .column.u-mb-col
          AppCardBox
            AppLink(to="/contact" :title="$t('contact')"  class="cardBox-url")
            h4 {{$t('contact')}}
            p {{$t('contactDesc')}}

    .u-mb-mi
</template>

<script>
import { CreateInquiry } from '~/graphql/Shame.gql';
import { mapActions } from 'vuex';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import SelectInput from '~/components/inputs/SelectInput';
import PhoneInput from '~/components/inputs/PhoneInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.minimal';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    TextInput,
    SelectInput,
    PhoneInput,
    ValidationObserver,
    ValidationProvider
  },
  directives: {
    load
  },
  data() {
    return {
      reasons: ['projects', 'services', 'company', 'others'].map(key => {
        return { value: key, title: this.$t(`allReasons.${key}`) };
      }),
      showOptional: true,
      rateLast: 3,
      rate: null,
      reason: '',
      phone: '',
      firstName: '',
      lastName: '',
      email: '',
      title: '',
      message: '',
      isSubmitting: false,
      successSend: false,
      recaptchaValid: false
    };
  },
  created() {
    if (this.$store.state.auth.isLoggedIn) {
      const user = this.$store.state.auth.user;
      this.email = user.email;
      this.name = `${user.firstName} ${user.lastName}`;
    }
  },
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    }),
    async onSubmit() {
      try {
        if (!this.recaptchaValid) {
          this.error(this.$t('forms.recaptchaRequired'));
          return;
        }
        /*eslint-disable */
        let data = {
          type: 'FEEDBACK',
          title: this.title,
          firstName: this.firstName,
          lastName: this.lastName,
          message: this.message,
          rate: this.rate,
          reason: this.reason.value
        };

        if (this.email && this.email.length) {
          data.email = this.email;
        }

        if (this.phone && this.phone.length) {
          data.phone = this.phone;
        }
        this.isSubmitting = true;

        await this.$api.mutate({
          mutation: CreateInquiry,
          variables: {
            input: data
          }
        });

        let name = this.firstName + ' ' + this.lastName + ',';
        // this.success(`${name} We got your feedback thank you :)`);
        this.successSend = true;
        this.rateLast = this.rate;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        this.title = '';
        this.name = '';
        this.firstName = '';
        this.lastName = '';
        this.rate = '';
        this.phone = '';
        this.email = '';
        this.message = '';
        this.reason = '';
        requestAnimationFrame(() => {
          this.$refs.observer.reset();
        });
        await this.$recaptcha.reset();
        this.recaptchaValid = false;
      } catch (err) {
        this.error(err.message);
      } finally {
        this.isSubmitting = false;
      }
    },

    onError() {
      this.recaptchaValid = false;
    },
    onSuccess() {
      this.recaptchaValid = true;
    },
    onExpired() {
      this.recaptchaValid = false;
    }
  },
  async mounted() {
    try {
      await this.$recaptcha.init();
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<style lang="stylus" scoped>
.feedbackBox
  border: 3px solid $clBlack

  &-header
    padding: 20px
    display flex
    justify-content space-between
    align-items center
  &-body
    padding:0  20px
.feedback
  &-text
    position absolute
    font-size:10px
    left: 50%
    transform:translateX(-50%)
    top: calc(100% + 5px)
    +mq($until: 'tablet')
      font-size 14px



 .feedback {
  --normal: #ECEAF3;
  --normal-shadow: #D9D8E3;
  --normal-mouth: #9795A4;
  --normal-eye: #595861;
  --active: #F8DA69;
  --active-shadow: #F4B555;
  --active-mouth: #F05136;
  --active-eye: #313036;
  --active-tear: #76b5e7;
  --active-shadow-angry: #e94f1d;
  margin: 0 15px unitRes(60, 160) 15px;
  padding: 0;
  list-style: none;
  display: -webkit-box;
  display: flex;
  justify-content space-between
}
.feedback li {
  position: relative;
  border-radius: 50%;
  background: var(--sb, var(--normal));
  box-shadow: inset 3px -3px 4px var(--sh, var(--normal-shadow));
  -webkit-transition: background .4s, box-shadow .4s, -webkit-transform .3s;
  transition: background .4s, box-shadow .4s, -webkit-transform .3s;
  transition: background .4s, box-shadow .4s, transform .3s;
  transition: background .4s, box-shadow .4s, transform .3s, -webkit-transform .3s;
  -webkit-tap-highlight-color: transparent;
  transform scale(2.3)
  +mq($until: 'tablet'){
      transform scale(1.6)
  }
  +mq($until: 'mobile'){
    transform scale(1.2)
  }

}
.feedback li:not(:last-child) {
  margin-right: 60px;
  +mq($until: 'tablet'){
      margin-right: 40px;
  }
  +mq($until: 'mobile'){
      margin-right: 20px;
  }
}
.feedback li div {
  width: 40px;
  height: 40px;
  position: relative;
  -webkit-transform: perspective(240px) translateZ(4px);
          transform: perspective(240px) translateZ(4px);
}
.feedback li div svg, .feedback li div:before, .feedback li div:after {
  display: block;
  position: absolute;
  left: var(--l, 9px);
  top: var(--t, 13px);
  width: var(--w, 8px);
  height: var(--h, 2px);
  -webkit-transform: rotate(var(--r, 0deg)) scale(var(--sc, 1)) translateZ(0);
          transform: rotate(var(--r, 0deg)) scale(var(--sc, 1)) translateZ(0);
}
.feedback li div svg {
  fill: none;
  stroke: var(--s);
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
  -webkit-transition: stroke .4s;
  transition: stroke .4s;
}
.feedback li div svg.eye {
  --s: var(--e, var(--normal-eye));
  --t: 17px;
  --w: 7px;
  --h: 4px;
}
.feedback li div svg.eye.right {
  --l: 23px;
}
.feedback li div svg.mouth {
  --s: var(--m, var(--normal-mouth));
  --l: 11px;
  --t: 23px;
  --w: 18px;
  --h: 7px;
}
.feedback li div:before, .feedback li div:after {
  content: '';
  z-index: var(--zi, 1);
  border-radius: var(--br, 1px);
  background: var(--b, var(--e, var(--normal-eye)));
  -webkit-transition: background .4s;
  transition: background .4s;
}
.feedback li.angry {
  --step-1-rx: -24deg;
  --step-1-ry: 20deg;
  --step-2-rx: -24deg;
  --step-2-ry: -20deg;
}
.feedback li.angry div:before {
  --r: 20deg;
}
.feedback li.angry div:after {
  --l: 23px;
  --r: -20deg;
}
.feedback li.angry div svg.eye {
  stroke-dasharray: 4.55;
  stroke-dashoffset: 8.15;
}
.feedback li.angry.active {
  -webkit-animation: angry 1s linear;
          animation: angry 1s linear;
}
.feedback li.angry.active div:before {
  --middle-y: -2px;
  --middle-r: 22deg;
  -webkit-animation: toggle .8s linear forwards;
          animation: toggle .8s linear forwards;
}
.feedback li.angry.active div:after {
  --middle-y: 1px;
  --middle-r: -18deg;
  -webkit-animation: toggle .8s linear forwards;
          animation: toggle .8s linear forwards;
}
.feedback li.sad {
  --step-1-rx: 20deg;
  --step-1-ry: -12deg;
  --step-2-rx: -18deg;
  --step-2-ry: 14deg;
}
.feedback li.sad div:before, .feedback li.sad div:after {
  --b: var(--active-tear);
  --sc: 0;
  --w: 5px;
  --h: 5px;
  --t: 15px;
  --br: 50%;
}
.feedback li.sad div:after {
  --l: 25px;
}
.feedback li.sad div svg.eye {
  --t: 16px;
}
.feedback li.sad div svg.mouth {
  --t: 24px;
  stroke-dasharray: 9.5;
  stroke-dashoffset: 33.25;
}
.feedback li.sad.active div:before, .feedback li.sad.active div:after {
  -webkit-animation: tear .6s linear forwards;
          animation: tear .6s linear forwards;
}
.feedback li.ok {
  --step-1-rx: 4deg;
  --step-1-ry: -22deg;
  --step-1-rz: 6deg;
  --step-2-rx: 4deg;
  --step-2-ry: 22deg;
  --step-2-rz: -6deg;
}
.feedback li.ok div:before {
  --l: 12px;
  --t: 17px;
  --h: 4px;
  --w: 4px;
  --br: 50%;
  box-shadow: 12px 0 0 var(--e, var(--normal-eye));
}
.feedback li.ok div:after {
  --l: 13px;
  --t: 26px;
  --w: 14px;
  --h: 2px;
  --br: 1px;
  --b: var(--m, var(--normal-mouth));
}
.feedback li.ok.active div:before {
  --middle-s-y: .35;
  -webkit-animation: toggle .2s linear forwards;
          animation: toggle .2s linear forwards;
}
.feedback li.ok.active div:after {
  --middle-s-x: .5;
  -webkit-animation: toggle .7s linear forwards;
          animation: toggle .7s linear forwards;
}
.feedback li.good {
  --step-1-rx: -14deg;
  --step-1-rz: 10deg;
  --step-2-rx: 10deg;
  --step-2-rz: -8deg;
}
.feedback li.good div:before {
  --b: var(--m, var(--normal-mouth));
  --w: 5px;
  --h: 5px;
  --br: 50%;
  --t: 22px;
  --zi: 0;
  opacity: .5;
  box-shadow: 16px 0 0 var(--b);
  -webkit-filter: blur(2px);
          filter: blur(2px);
}
.feedback li.good div:after {
  --sc: 0;
}
.feedback li.good div svg.eye {
  --t: 15px;
  --sc: -1;
  stroke-dasharray: 4.55;
  stroke-dashoffset: 8.15;
}
.feedback li.good div svg.mouth {
  --t: 22px;
  --sc: -1;
  stroke-dasharray: 13.3;
  stroke-dashoffset: 23.75;
}
.feedback li.good.active div svg.mouth {
  --middle-y: 1px;
  --middle-s: -1;
  -webkit-animation: toggle .8s linear forwards;
          animation: toggle .8s linear forwards;
}
.feedback li.happy div {
  --step-1-rx: 18deg;
  --step-1-ry: 24deg;
  --step-2-rx: 18deg;
  --step-2-ry: -24deg;
}
.feedback li.happy div:before {
  --sc: 0;
}
.feedback li.happy div:after {
  --b: var(--m, var(--normal-mouth));
  --l: 11px;
  --t: 23px;
  --w: 18px;
  --h: 8px;
  --br: 0 0 8px 8px;
}
.feedback li.happy div svg.eye {
  --t: 14px;
  --sc: -1;
}
.feedback li.happy.active div:after {
  --middle-s-x: .95;
  --middle-s-y: .75;
  -webkit-animation: toggle .8s linear forwards;
          animation: toggle .8s linear forwards;
}
.feedback li:not(.active) {
  cursor: pointer;
}
// .feedback li:not(.active):active {
//   -webkit-transform: scale(0.925);
//           transform: scale(0.925);
// }
.feedback li.active {
  --sb: var(--active);
  --sh: var(--active-shadow);
  --m: var(--active-mouth);
  --e: var(--active-eye);
}
.feedback li.active div {
  -webkit-animation: shake .8s linear forwards;
          animation: shake .8s linear forwards;
}



@keyframes shake {
  30% {
    -webkit-transform: perspective(240px) rotateX(var(--step-1-rx, 0deg)) rotateY(var(--step-1-ry, 0deg)) rotateZ(var(--step-1-rz, 0deg)) translateZ(10px);
            transform: perspective(240px) rotateX(var(--step-1-rx, 0deg)) rotateY(var(--step-1-ry, 0deg)) rotateZ(var(--step-1-rz, 0deg)) translateZ(10px);
  }
  60% {
    -webkit-transform: perspective(240px) rotateX(var(--step-2-rx, 0deg)) rotateY(var(--step-2-ry, 0deg)) rotateZ(var(--step-2-rz, 0deg)) translateZ(10px);
            transform: perspective(240px) rotateX(var(--step-2-rx, 0deg)) rotateY(var(--step-2-ry, 0deg)) rotateZ(var(--step-2-rz, 0deg)) translateZ(10px);
  }
  100% {
    -webkit-transform: perspective(240px) translateZ(4px);
            transform: perspective(240px) translateZ(4px);
  }
}

@keyframes tear {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-2px) scale(0) translateZ(0);
            transform: translateY(-2px) scale(0) translateZ(0);
  }
  50% {
    -webkit-transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
            transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
  }
  20%,
    80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
            transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
  }
}

@keyframes toggle {
  50% {
    -webkit-transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
            transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
  }
}

@keyframes angry {
  40% {
    background: var(--active);
  }
  45% {
    box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
  }
}
html[lang^='ar']{
  .feedback {

  }
  .feedback li:not(:last-child){
    margin-right: 0;
    margin-left: 60px;
    +mq($until: 'tablet'){
      margin-right: 0;
      margin-left: 40px;
    }
    +mq($until: 'mobile'){
        margin-right: 0;
        margin-left: 20px;
    }
  }
}

.formPage

  &-loader
    display none
    justify-content center
    align-items center
    min-height 80vh
  &-success
    display none
    justify-content center
    align-items center
    min-height 80vh
    text-align center
    &-content
      max-width 960px
  &.is-submitting
    .formPage
      &-loader
        display flex
    >*
      display none
  &.is-succeed
    >*
      display none
    .formPage-success
      display flex
</style>

<i18n>
{
  "en": {
    "pageTitle":"Feedback",
    "pageDesc":"Say hello to Baianat team. Ask all your burning questions.",
    "mantra":"Your insights | inspire us !",
    "email":"Email",
    "phone":"Phone",
    "customerCare":"Customer care",
    "allReasons": {
      "projects": "Projects",
      "services": "Services",
      "company": "Company",
      "others": "Others"
    },
    "angry":"Angry",
    "sad":"Sad",
    "ok":"Ok",
    "good":"Good",
    "happy":"Happy",
    "cc":"Customer care",
    "ccDesc":"Track your projects flow and open tickets whenever needed.",
    "contact":"Contact us",
    "contactDesc":"Get immediate assistance through phone calls or emails.",
    "thankYouMessage":"Thank You so much! we appreciate your inputs ^_^",
    "submitAnotherFeedback":"Submit another feedback?",
    "rates":{
      "1":"We feel so sorry about that 😔 We promise to do our best for you",
      "2":"We feel bad that you are sad 😔 We will surely consider all your comments",
      "3":"Thank you so much! We appreciate your inputs 🌷",
      "4":"Thank you! We are pretty sure your insights will make our experience terrific 😀",
      "5":"We are happy to hear from you and will be always looking forward to your suggestions! 🥰"
    }


  },
  "ar": {
    "pageTitle":"شكاوي واقتراحات",
    "pageDesc":"إذا كان لديك أي رأي أو اقتراح أو حتى شكوى يمكنك أن تخبرنا على الفور وسوف نتواصل معك.",
    "mantra":"آراؤكم  تُلْهِمُنَا :)",
    "email":"البريد الالكتروني",
    "phone":"الهاتف",
    "customerCare":"خدمة العملاء",
    "allReasons": {
      "projects": "المشاريع",
      "services": "الخدمات",
      "company": "الشركة",
      "others": "أخرى"
    },
    "angry":"غاضب",
    "sad":"حزين",
    "ok":"مقبول",
    "good":"جيد",
    "happy":"سعيد",
    "cc":"خدمة العملاء",
    "ccDesc":"تابع مشاريعك وتواصل معنا عن طريق بطاقات الدعم الفني.",
    "contact":"اتصل بنا",
    "contactDesc":"احصل على المساعدة الفورية من خلال المكالمات الهاتفية أو رسائل البريد الإلكتروني.",
    "thankYouMessage":"شكراً جزيلاً لك! نقدر اهتمامك بجعل تجربتنا أفضل ^_^",
    "submitAnotherFeedback":"لديك اقتراح آخر؟",
    "rates":{
      "1":"نشعر بالأسف الشديد بشأن ذلك 😔 نعدك بأن نبذل قصارى جهدنا من أجلك",
      "2":"نشعر بالسوء لأنك حزين 😔 وبالتأكيد سوف ننظر باهتمام في جميع تعليقاتك",
      "3":"شكرًا جزيلًا لك! نقدر كل المعلومات التي أرسلتها إلينا 🌷",
      "4":"شكرًا لك! متأكدون أن رؤيتك وكلماتك سوف تجعل تجربتنا رائعة 😃 ",
      "5":"يسعدنا أن نستمع إليك دائمًا ونعرف جميع مقترحاتك 🥰"
    }
  }
}
</i18n>
